import { Button } from "app/components/button";
import { CardBody } from "app/components/card-body";
import { CardFooter } from "app/components/card-footer";
import { CardHeader } from "app/components/card-header";
import { Checkbox } from "app/components/checkbox";
import { Column } from "app/components/column";
import { DFlexResponsive } from "app/components/d-flex-responsive";
import { Option } from "app/components/option";
import { Row } from "app/components/row";
import { Select } from "app/components/select";
import { useResourcesContext, useEmpresa } from "app/contexts";
import { useNavigate } from "react-router-dom";

export function AfiliacionForm() {
  const navigate = useNavigate();
  const { formasDePago, frecuenciasDePago } = useResourcesContext();

  const { empresa, setEmpresa } = useEmpresa();

  function handleSubmit(e) {
    e.preventDefault();

    navigate("../archivos-adjuntos");
  }

  return (
    <div className="col-sm-12 col-xl-6 offset-xl-3">
      <form className="card" onSubmit={handleSubmit}>
        <CardHeader header="Afiliación a la CCIA (opcional)" />

        <CardBody>
          <Row>
            <Column>
              <Checkbox
                label="¿Desea afiliarse a la CCIA?"
                checked={empresa.empresa_afiliada}
                onChange={(e) =>
                  setEmpresa((empresa) => ({
                    ...empresa,
                    empresa_afiliada: e.target.checked,
                  }))
                }
              />
            </Column>

            <Column>
              <Select
                placeholder="Forma de pago"
                value={empresa.forma_de_pago_id}
                onChange={(e) =>
                  setEmpresa((empresa) => ({
                    ...empresa,
                    forma_de_pago_id: parseInt(e.target.value),
                  }))
                }
                disabled={!empresa.empresa_afiliada}
                required={empresa.empresa_afiliada}
              >
                {formasDePago.map((forma) => (
                  <Option
                    key={forma.forma_de_pago_id}
                    value={forma.forma_de_pago_id}
                    title={forma.forma_de_pago_nombre}
                  />
                ))}
              </Select>
            </Column>

            <Column>
              <Select
                placeholder="Frecuencia de pago"
                value={empresa.frecuencia_de_pago_id}
                onChange={(e) =>
                  setEmpresa((empresa) => ({
                    ...empresa,
                    frecuencia_de_pago_id: parseInt(e.target.value),
                  }))
                }
                disabled={!empresa.empresa_afiliada}
                required={empresa.empresa_afiliada}
              >
                {frecuenciasDePago.map((frecuencia) => (
                  <Option
                    key={frecuencia.frecuencia_de_pago_id}
                    value={frecuencia.frecuencia_de_pago_id}
                    title={frecuencia.frecuencia_de_pago_nombre}
                  />
                ))}
              </Select>
            </Column>

            <Column>
              <br />

              <a
                href="https://cciahn.org/socios.html#wsb-element-004711b8-26a8-4cc3-be90-4b754d206d15"
                target="_blank"
                rel="noreferrer"
              >
                Conozca los beneficios de afiliarse (haga clic aquí)
              </a>
            </Column>
          </Row>
        </CardBody>

        <CardFooter>
          <DFlexResponsive justifyContent="end">
            <Button
              color="secondary"
              outline
              title="Anterior"
              onClick={() => navigate("../actividad-economica")}
            />

            <Button type="submit" color="success" title="Siguiente" />
          </DFlexResponsive>
        </CardFooter>
      </form>
    </div>
  );
}
